let modalName
let zIndex = 1050

$(document)
	.on('click', '[data-modal-init]', function (e) {
		e.preventDefault()
		const container = 'body'

		$(root).removeClass(`is_modal-${ modalName }`)

		modalName = $(this).data('modal-init')

		if (modalName === 'ajax') {
			const url = $(this).data('ajax-url') || $(this).attr('href')
			const name = $(this).data('ajax-name')
			const heading = $(this).data('ajax-heading')

			$.ajax({
				url: url,
				type: 'get',
				dataType: 'html',
				beforeSend() {
					$(`[data-modal-init="${ name }"], [data-modal="${ name }"]`).remove()
				},
				success(data) {
					const template = `
						<button class="y-btn" type="button"
								style="pointer-events: none; opacity: 0; position: absolute; right: 100%;"
								data-modal-init="${ name }"
						>
							<span class="y-btn__txt">${ heading }</span>
						</button>
						<div class="y-modal is_${ name }" data-modal="${ name }">
							<div class="y-modal__inner">
								<div class="y-modal__header">
									<div class="y-modal__title">${ heading }</div>
									<button type="button" class="y-btn y-modal__btn-close"
											data-modal-close aria-label="close modal ${ name }"
									>
										<span class="y-btn__icn"></span>
										<span class="y-btn__txt">close</span>
									</button>
								</div>
								<div class="y-modal__main" data-scroll-check>
									<div class="y-modal__main-inner" data-scroll-inner>
										<div class="y-editor y-modal__${ name }">${ data }</div>
									</div>
								</div>
							</div>
						</div>
					`
					$(root).append(template)
				},
				complete() {
					$(`[data-modal-init="${ name }"]`).trigger('click')
				}
			})

		}

		const modal = `[data-modal="${ modalName }"]`
		const modalOverlay = `[data-overlay]`
		const modalDouble = $(this).parents('[data-modal]').hasClass('is_open')

		if ($(modal).length && $(modalOverlay).length === 0 || $(modal).length && modalDouble) {

			if (modalDouble) {
				$(this).parents('[data-modal]').css('z-index', --zIndex)
				zIndex += 1
			}

			$(this).addClass('is_active')

			if (!modalDouble) {
				$(root).css({
					'--scroll-size_w': `${ scrollSize().width }px`,
					'--scroll-size_h': `${ scrollSize().height }px`
				}).addClass(`is_modal-${ modalName } is_stop-scroll`)
			}

			$(modal)
				.addClass('is_open').css('z-index', zIndex)
				.off('transitionend webkitTransitionEnd oTransitionEnd')

			if ($(modalOverlay).length === 0) {
				$(modalOverlay).off('transitionend webkitTransitionEnd oTransitionEnd')
				$(`<div class="y-overlay" data-overlay data-modal-close style="z-index: ${ --zIndex}" />`)
					.appendTo(container)
					.fadeIn(() => {
						$(modalOverlay)
							.addClass('is_open')
							.on('transitionend webkitTransitionEnd oTransitionEnd', () => {
								$(modalOverlay).addClass(`is_${ modalName }`)
							})
					})
			}

			const scrollCheck = '[data-scroll-check]'
			if ($(scrollCheck).length) {

				$(scrollCheck).each(function () {

					hasScroll(this)

					$(this).resize(() => {

						hasScroll(this)

					})
				})

			}

			if (modalName === 'modalName') {
				// scripts for modals
			}

		}
	})
	.on('click', '[data-modal-close]', function () {
		$(`[data-modal]`)
			.removeClass('is_open')
			.on('transitionend webkitTransitionEnd oTransitionEnd', function () {
				const _this = this
				$('[data-overlay]')
					.removeClass('is_open')
					.on('transitionend webkitTransitionEnd oTransitionEnd', function () {
						$(this).remove()

						$(root).removeClass(`is_modal-${ modalName } is_stop-scroll`).css({
							'--scroll-size_w': ``,
							'--scroll-size_h': ``
						})

						$('[data-modal-init]').removeClass('is_active')

						$(_this).css('z-index', '').off('transitionend webkitTransitionEnd oTransitionEnd')
					})

			})
		zIndex = 1025
	})
